function Plugins($pool, $dataProxy, controller) {
  const plugins = new Map()

  const api = {
    add(pluginName, Plugin) {
      plugins.set(pluginName, Plugin($pool, $dataProxy, plugins, controller))

      return this
    },
    emit(eventName, payload = {}) {
      plugins.forEach((plugin) => {
        plugin(eventName, payload)
      })

      return this
    },
  }

  return Object.freeze(api)
}

export default Plugins
